export function getPriceDetails(activity) {
  var _a, _b, _c, _d, _e;
  var _f = activity.leadTicketPrice.priceLockup,
    strikeThroughPrice = _f.strikeThroughPrice,
    lockupPrice = _f.lockupPrice,
    lockupFormattedPoints = _f.lockupFormattedPoints,
    accessibilityPrice = _f.accessibilityPrice;
  var priceSubtextFirst = (_b = (_a = activity.leadTicketPrice.priceLockup) === null || _a === void 0 ? void 0 : _a.priceSubtextFirst) === null || _b === void 0 ? void 0 : _b.map(function (message) {
    return message;
  });
  var priceDisclaimer = activity.leadTicketPrice.disclaimer;
  var leadingCaption = (_c = activity.leadTicketPrice.priceLockup) === null || _c === void 0 ? void 0 : _c.leadingCaption;
  var isPointsFirstDisplay = (_d = activity.leadTicketPrice.priceLockup) === null || _d === void 0 ? void 0 : _d.isPointsFirst;
  var isStrikeThroughFirstDisplay = (_e = activity.leadTicketPrice.priceLockup) === null || _e === void 0 ? void 0 : _e.isStrikeThroughFirst;
  return {
    strikeThroughPrice: strikeThroughPrice,
    priceSubtextFirst: priceSubtextFirst,
    lockupPrice: lockupPrice,
    lockupFormattedPoints: lockupFormattedPoints,
    accessibilityPrice: accessibilityPrice,
    priceDisclaimer: priceDisclaimer,
    leadingCaption: leadingCaption,
    isPointsFirstDisplay: isPointsFirstDisplay,
    isStrikeThroughFirstDisplay: isStrikeThroughFirstDisplay
  };
}